/* eslint-disable max-len */
import { ReactNode } from "react";

const tasks: { title: string; description: string; content?: ReactNode }[] = [
    {
        title: "Vertretung des Berufsstandes",
        description:
      "Eine der wichtigsten Aufgaben des BCD ist die vertretungsstarke und kompetente Repräsentation des Berufsstandes gegenüber politischen Entscheidungsträgern, Kassenärztlichen Vereinigungen, Fachgesellschaften und weiteren Institutionen im Gesundheitswesen.",
        content: (
            <div>
                <p>
                    Eine der wichtigsten Aufgaben des BCD ist die vertretungsstarke und
                    kompetente Repräsentation des Berufsstandes gegenüber politischen
                    Entscheidungsträgern, Kassenärztlichen Vereinigungen,
                    Fachgesellschaften und weiteren Institutionen im Gesundheitswesen.
                </p>
                <p>
                    Kurzgefasst bedeutet dies: Wir geben der Koloproktologie eine Stimme!
                </p>
                <p>
                    Wir engagieren uns dafür, dass die besonderen Anforderungen unseres
                    Fachgebietes in gesundheitspolitischen Diskussionen berücksichtigt
                    werden, etwa bei Fragen der Versorgungsgestaltung, der Vergütung, der
                    Qualitätsanforderungen oder der Weiterentwicklung medizinischer
                    Strukturen. Der BCD nimmt Stellung zu Gesetzesvorhaben, arbeitet in
                    Gremien und Arbeitsgruppen mit und setzt sich für faire,
                    praxistaugliche Rahmenbedingungen ein.
                </p>
            </div>
        )
    },
    {
        title: "Erarbeitung grundlegender beruflicher Standards",
        description:
      "Entwicklung, Definition und kontinuierliche Aktualisierung fachlicher und beruflicher Standards sowie Handlungsempfehlungen.",
        content: (
            <div>
                <p>
                    Eine weitere zentrale Aufgabe des Verbandes ist die Entwicklung,
                    Definition und kontinuierliche Aktualisierung fachlicher und
                    beruflicher Standards sowie Handlungsempfehlungen.
                </p>
                <p>
                    Das heißt: Wir formulieren, welche strukturellen, organisatorischen
                    und medizinischen Anforderungen für eine moderne und qualitativ
                    hochwertige koloproktologische Versorgung unerlässlich sind.
                </p>
                <p>
                    Dazu zählen beispielsweise Handlungsempfehlungen zur Hygiene,
                    Praxisorganisation, Qualitätskriterien, leitliniennahe
                    Behandlungsempfehlungen, praxisrelevante Standards in Diagnostik und
                    Therapie sowie die Mitwirkung an Zertifizierungs- und
                    Qualitätssicherungsmaßnahmen.
                </p>
                <p>
                    Unser Ziel ist es, einheitliche und nachvollziehbare Rahmenbedingungen
                    zu schaffen, die sowohl allen ärztlich Tätigen als auch den
                    Patient*innen zugutekommen.
                </p>
                <p>
                    Der BCD arbeitet in allen Fragen zu beruflichen Standards und
                    Handlungsempfehlungen eng mit der Deutschen Gesellschaft für
                    Koloproktologie (DGK) zusammen.
                </p>
            </div>
        )
    },
    {
        title: "Interessenvertretung in der Öffentlichkeit",
        description:
      "Als Berufsverband vertreten wir die Anliegen der  Koloproktolog*innen  auch gegenüber der breiten Öffentlichkeit.",
        content: (
            <div>
                <p>
                    Als Berufsverband vertreten wir die Anliegen der Koloproktolog*innen
                    auch gegenüber der breiten Öffentlichkeit.
                </p>
                <p>
                    Das sieht konkret so aus: Wir informieren über das Fachgebiet, klären
                    über typische Krankheitsbilder auf und schaffen Bewusstsein für die
                    Bedeutung spezialisierter Versorgung.
                </p>
                <p>
                    Hierzu gehören Pressearbeit, Informationskampagnen,
                    Öffentlichkeitsveranstaltungen sowie die Zusammenarbeit mit
                    Patientenorganisationen und Medien. Wir möchten damit dazu beitragen,
                    Hemmschwellen abzubauen, Fehlinformationen zu vermeiden und das
                    Vertrauen in die Kompetenz unseres Fachgebietes zu stärken.
                </p>
            </div>
        )
    },
    {
        title:
      "Kompetenter Ansprechpartner bei Fragen der vertrags- und privatärztlichen Honorierung ",
        description:
      "Die Honorierung ärztlicher Leistungen ist ein komplexes Feld - sowohl im vertragsärztlichen als auch im privatärztlichen Bereich. Der BCD unterstützt seine Mitglieder als zuverlässiger, fachkundiger Ansprechpartner bei allen Fragen rund um EBM, GOÄ, Hybrid-DRG, Abrechnung, Wirtschaftlichkeit und vertragsrechtliche Rahmenbedingungen.",
        content: (
            <div>
                <p>
                    Die Honorierung ärztlicher Leistungen ist ein komplexes Feld - sowohl
                    im vertragsärztlichen als auch im privatärztlichen Bereich. Der BCD
                    unterstützt seine Mitglieder als zuverlässiger, fachkundiger
                    Ansprechpartner bei allen Fragen rund um EBM, GOÄ, Hybrid-DRG,
                    Abrechnung, Wirtschaftlichkeit und vertragsrechtliche
                    Rahmenbedingungen.
                </p>
                <p>
                    Wir informieren regelmäßig über aktuelle Änderungen, bieten Beratung,
                    unterstützen bei der Auslegung von Abrechnungsmodalitäten und setzen
                    uns für eine angemessene Bewertung koloproktologischer Leistungen ein.
                    Unser Ziel ist es, die ökonomischen Grundlagen einer hochwertigen
                    Patientenversorgung zu sichern.
                </p>
            </div>
        )
    },
    {
        title: "Fort- und Weiterbildung",
        description:
      "Der BCD bietet ein breites Spektrum an Fort- und Weiterbildungsangeboten an",
        content: (
            <div>
                <p>
                    Die kontinuierliche fachliche Weiterentwicklung ist für unser
                    Fachgebiet unverzichtbar.
                </p>
                <p>
                    Deshalb bietet der BCD ein breites Spektrum an Fort- und
                    Weiterbildungsangeboten an, darunter:
                </p>
                <ul>
                    <li>
                        {" "}
                        ein jährlich stattfindender Koloproktologen-Kongress mit Symposien
                        und internationaler Beteiligung in enger Zusammenarbeit mit der
                        deutschen Gesellschaft für Koloproktologie (DGK)
                    </li>
                    <li>praxisorientierte Workshops</li>
                    <li>
                        zertifizierte Fortbildungsveranstaltungen, insbesondere auch den
                        „Grundkurs Koloproktologie“, der die theoretische Basis zum Erwerb
                        der Zusatzbezeichnung „Proktologie“ bildet
                    </li>
                    <li>
                        zertifizierte Fortbildungsveranstaltungen, insbesondere auch den
                        „Grundkurs Koloproktologie“, der die digitale Lernformate
                    </li>
                    <li>
                        Austauschmöglichkeiten mit Experten unterschiedlichster Bereiche
                    </li>
                </ul>
                <p>
                    Damit tragen wir dazu bei, dass unsere Mitglieder stets über aktuelle
                    wissenschaftliche Erkenntnisse, technische Innovationen und bewährte
                    Behandlungsmethoden informiert sind.
                </p>
            </div>
        )
    },
    {
        title: "Unterstützung bei Hospitationen",
        description:
      "Die Unterstützung bei Hospitationen ist eine der wichtigsten Aufgaben des BCD. Sie umfasst die Unterstützung bei Hospitationen der Koloproktologen.",
        content: (
            <div>
                <p>
                    Ein besonderes Anliegen des Verbandes ist die Förderung kollegialen
                    Austauschs und praktischer Lernerfahrungen.
                </p>
                <p>
                    Wir unterstützen unsere Mitglieder bei der Organisation und
                    Vermittlung von Hospitationen in spezialisierten Praxen und Kliniken.
                    Damit ermöglichen wir Einblicke in unterschiedliche Behandlungs- und
                    Versorgungsmodelle und fördern hiermit speziell den Erwerb praktischer
                    Fähigkeiten, um die Voraussetzungen für den Erwerb der
                    Zusatzbezeichnung Proktologie zu erhalten. Die persönliche Vernetzung
                    innerhalb des Fachgebietes mit Hospitationen sind ein wichtiger
                    Baustein, um die Qualität der koloproktologischen Versorgung
                    nachhaltig zu sichern und weiterzuentwickeln.
                </p>
            </div>
        )
    },
    {
        title: "Herausgabe der Verbands- und Fachzeitschrift „Coloproctology“",
        description:
      "Die Herausgabe der Verbands- und Fachzeitschrift „Coloproctology“ ist eine der wichtigsten Aufgaben des BCD. Sie umfasst die Herausgabe der Verbands- und Fachzeitschrift „Coloproctology“."
    }
];

export default tasks;
